export const shortenSize = (size: string) => {
  const matches = size.toLowerCase().match(/^x{3,}/);

  if (matches) {
    return `${matches[0].length}X${size.charAt(size.length - 1)}`;
  }

  return size;
};
